import { TranslatePipe } from '@ngx-translate/core';
import { Component, Input, OnInit } from '@angular/core';
import * as moment from 'moment';

import { TrainerService } from '../../../../_services';
import { TrainerQueryOutput } from '../models/trainer.model';

@Component({
    selector: 'trainer-detail-evaluation',
    templateUrl: './evaluation.component.html',
    styleUrls: [
        '../../trainer.component.scss',
        '../detail.component.scss',
        './evaluation.style.scss',
    ],
    providers: [TranslatePipe],
})
export class TrainerDetailEvaluationComponent implements OnInit {
    @Input() trainer: TrainerQueryOutput;
    currentTrainer: any;
    sessions: any[];
    trainerScoresAverage: {};
    scorePropertieNames: string[];
    dataLoaded = false;

    public chartData: any = {};

    constructor(private trainerService: TrainerService) {}

    ngOnInit() {
        this.currentTrainer = this.trainer;
        this.initChart();

        this.getEvaluations();

        this.scorePropertieNames = [
            'trainerPedagogicalQuality',
            'trainerAnswerQuality',
            'trainerAvailability',
            'trainerSubjectKnowledge',
        ];
    }

    getEvaluations() {
        this.trainerService
            .getEvaluations(this.trainer.id)
            .subscribe((sessions) => {
                this.sessions = sessions.sort((sessionA, sessionB) =>
                    sessionA.sessionStartDate.localeCompare(
                        sessionB.sessionStartDate
                    )
                );

                this.populateChartLabels();

                this.initTrainerScoresAverage();
                this.computeScoreAverages();
                this.computeAverageSessionScores();
            });
    }

    public initTrainerScoresAverage(): void {
        this.trainerScoresAverage = {
            trainerAnswerQuality: 0,
            trainerAvailability: 0,
            trainerPedagogicalQuality: 0,
            trainerSubjectKnowledge: 0,
        };
    }

    public populateChartLabels(): void {
        this.sessions.forEach((session) => {
            this.chartData.lineChartLabels.push(
                moment(session['sessionStartDate'])
            );
        });
    }

    public initChartColors(): void {
        this.chartData.lineChartColors.push({
            backgroundColor: 'rgba(148,159,177,0.2)',
            borderColor: 'rgba(148,159,177,1)',
            pointBackgroundColor: 'rgba(148,159,177,1)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(148,159,177,0.8)',
        });
    }

    public populateChartValues(): void {
        let lineEvalValues = [];

        this.sessions.forEach((session) => {
            lineEvalValues.push(session['averageTotalScore']);
        });

        this.chartData.lineChartData = [
            {
                data: lineEvalValues,
                label: '',
                sessions: this.sessions,
            },
        ];
        this.dataLoaded = true;
    }

    public chartClicked(e: any): void {
        console.log(e);
    }

    public chartHovered(e: any): void {
        console.log(e);
    }

    computeScoreAverages() {
        this.sessions.forEach((currEval) => {
            this.scorePropertieNames.forEach((property) => {
                if (currEval[property] !== null && currEval[property]) {
                    this.trainerScoresAverage[property] += currEval[property];
                }
            });
        });
        this.setScoresDecimalPrecision(1);
    }

    setScoresDecimalPrecision(precision: number) {
        this.scorePropertieNames.forEach((property) => {
            this.trainerScoresAverage[property] /= this.sessions.length;
            this.trainerScoresAverage[property] =
                Math.round(this.trainerScoresAverage[property] * 10) / 10;
        });
        this.sessions.forEach((session) => {
            this.scorePropertieNames.forEach((property) => {
                session[property] = Math.round(session[property] * 10) / 10;
            });
        });
    }

    computeAverageSessionScores() {
        this.sessions.forEach((session) => {
            session['averageTotalScore'] = 0;
            this.scorePropertieNames.forEach((property) => {
                session['averageTotalScore'] += session[property];
            });
            session['averageTotalScore'] /= this.scorePropertieNames.length;
            session['averageTotalScore'] =
                Math.round(session['averageTotalScore'] * 10) / 10;
        });
        this.populateChartValues();
    }

    private initChart() {
        this.chartData.lineChartColors = [];
        this.chartData.lineChartData = [];
        this.chartData.lineChartLegend = false;
        this.chartData.lineChartType = 'line';
        this.chartData.lineChartLabels = [];

        this.initChartColors();
        this.initChartOptions();
    }

    private initChartOptions() {
        this.chartData.lineChartOptions = {
            responsive: true,
            scales: {
                xAxes: [
                    {
                        type: 'time',
                        time: {
                            displayFormats: {
                                quarter: 'MMM YYYY',
                            },
                        },
                    },
                ],
                yAxes: [
                    {
                        ticks: {
                            min: 0,
                            max: 5,
                            maxTicksLimit: 6,
                        },
                    },
                ],
            },
            tooltips: {
                callbacks: {
                    title: function (item, data) {
                        return moment(item[0]['xLabel']['_i']).format(
                            'MMM YYYY'
                        );
                    },
                    label: function (item, data) {
                        let dateItem = item['xLabel']['_i'];
                        let session = data['datasets'][0]['sessions'].find(
                            (currSession) =>
                                currSession.sessionStartDate === dateItem
                        );
                        return session.trainingTitle;
                    },
                },
            },
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/_screens/trainer/detail/evaluation/evaluation.component.ts